/**
 * -------------------------------------------------------------------------------------------
 * OVERLAY
 * -------------------------------------------------------------------------------------------
 */

// Function to hide the overlay
function hidePrescriptionOverlay() {
  const overlay = document.getElementById("prescription-overlay-container");
  overlay?.classList.remove("active");

  // Also open the mini cart drawer if it's closed
  const miniCart = document.getElementById("mini-cart");
  if (miniCart && !miniCart.hasAttribute("open")) {
    miniCart.setAttribute("open", "");
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const stopIt = (event) => {
    const { target } = event;
    // Make sure target is an Element (not a text node, document, etc.)
    if (target instanceof Element) {
      if (target.matches(".prescription-overlay--close-button")) {
        event.stopImmediatePropagation();
        event.preventDefault();
      }
    }
  };

  // Only hide overlay when close button is clicked, not on every pointer event
  document.addEventListener(
    "click",
    (event) => {
      if (event.target.matches(".prescription-overlay--close-button")) {
        hidePrescriptionOverlay();
      }
      stopIt(event);
    },
    true,
  );

  // Restore all the event listeners for stopIt, but only call hidePrescriptionOverlay for close button
  document.addEventListener("mousedown", stopIt, true);
  document.addEventListener("mousemove", stopIt, true);
  document.addEventListener("mouseover", stopIt, true);
  document.addEventListener("mouseup", stopIt, true);
  document.addEventListener("touchend", stopIt, true);
  document.addEventListener("touchstart", stopIt, true);
  document.addEventListener("pointerover", stopIt, true);
  document.addEventListener("pointerenter", stopIt, true);
  document.addEventListener("pointermove", stopIt, true);
  document.addEventListener("pointerup", stopIt, true);
  document.addEventListener("pointerout", stopIt, true);
  document.addEventListener("pointerleave", stopIt, true);
  document.addEventListener("gotpointercapture", stopIt, true);
  document.addEventListener("lostpointercapture", stopIt, true);

  // Also use pointerdown for better touch/mouse support, but only for close button
  document.addEventListener(
    "pointerdown",
    (event) => {
      if (event.target.matches(".prescription-overlay--close-button")) {
        hidePrescriptionOverlay();
      }
      stopIt(event);
    },
    true,
  );
});

/**
 * -------------------------------------------------------------------------------------------
 * JSON ANIMATIONS
 * -------------------------------------------------------------------------------------------
 */

//JSON animations
document.addEventListener("DOMContentLoaded", function () {
  var animationContainers = document.querySelectorAll(".animation-container");
  var animationContainersMobile = document.querySelectorAll(
    ".animation-container-mobile",
  );

  animationContainers.forEach(function (container) {
    var jsonUrl = container.getAttribute("data-json-url");
    if (jsonUrl) {
      lottie.loadAnimation({
        container: container,
        renderer: "svg",
        loop: true,
        autoplay: true,
        path: jsonUrl,
      });
    }
  });

  animationContainersMobile.forEach(function (container) {
    var jsonUrl = container.getAttribute("data-json-url");
    if (jsonUrl) {
      lottie.loadAnimation({
        container: container,
        renderer: "svg",
        loop: true,
        autoplay: true,
        path: jsonUrl,
      });
    }
  });
});

/**
 * -------------------------------------------------------------------------------------------
 * GOOGLE ANALYTICS
 * -------------------------------------------------------------------------------------------
 */

// GTM + Consent Mode + Banner & Modal Logic
(function () {
  // ----- Helpers -----
  const getCookieValue = (name) => {
    const match = document.cookie.match(
      new RegExp("(^| )" + name + "=([^;]+)"),
    );
    return match ? decodeURIComponent(match[2]) : null;
  };

  const setConsentCookie = (analytics, marketing, performance) => {
    const consent = {
      con: {
        CMP: {
          a: analytics ? "1" : "",
          m: marketing ? "1" : "",
          p: performance ? "1" : "",
        },
      },
    };

    // Set the cookie to expire in 1 month
    const expires = new Date();
    expires.setMonth(expires.getMonth() + 1);

    document.cookie = `custom_tracking_consent=${encodeURIComponent(JSON.stringify(consent))}; path=/; SameSite=Lax; expires=${expires.toUTCString()}`;
    // document.cookie = `custom_tracking_consent=${encodeURIComponent(JSON.stringify(consent))}; path=/; SameSite=Lax`;
  };

  const getTrackingConsent = () => {
    const consentCookie = getCookieValue("custom_tracking_consent");

    if (!consentCookie)
      return {
        analytics: false,
        marketing: false,
        performance: false,
        cookie_set: false,
      };

    try {
      const consent = JSON.parse(consentCookie).con.CMP;

      return {
        analytics: consent.a === "1",
        marketing: consent.m === "1",
        performance: consent.p === "1",
        cookie_set: true,
      };
    } catch {
      return {
        analytics: false,
        marketing: false,
        performance: false,
        cookie_set: false,
      };
    }
  };

  // ----- Google Tag Consent Mode Setup -----
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }

  const updateConsentInGTM = (consent) => {
    const consentMap = { true: "granted", false: "denied" };

    gtag("consent", "update", {
      analytics_storage: consentMap[consent.analytics],
      ad_storage: consentMap[consent.marketing],
      ad_user_data: consentMap[consent.marketing],
      ad_personalization: consentMap[consent.marketing],
    });

    localStorage.setItem("analytics_storage", consentMap[consent.analytics]);
    localStorage.setItem("ad_storage", consentMap[consent.marketing]);

    window.dataLayer.push({
      event: "consentBannerUpdate",
      consentStatistics: consent.analytics,
      consentMarketing: consent.marketing,
    });
  };

  // ----- Initial Consent on Load -----
  const defaultConsent = {
    ad_storage: "denied",
    analytics_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
  };

  const savedAnalytics = localStorage.getItem("analytics_storage");
  const savedMarketing = localStorage.getItem("ad_storage");

  if (savedAnalytics) defaultConsent.analytics_storage = savedAnalytics;
  if (savedMarketing) {
    defaultConsent.ad_storage = savedMarketing;
    defaultConsent.ad_user_data = savedMarketing;
    defaultConsent.ad_personalization = savedMarketing;
  }

  gtag("consent", "default", defaultConsent);

  const currentConsent = getTrackingConsent();

  if (currentConsent.cookie_set) {
    // Send consent only if previously stored
    updateConsentInGTM(currentConsent);
  }

  // Add GTM Initialization function below
  // (function (w, d, s, l, i) {
  //   w[l] = w[l] || [];
  //   w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
  //   const f = d.getElementsByTagName(s)[0],
  //     j = d.createElement(s),
  //     dl = l !== 'dataLayer' ? '&l=' + l : '';
  //   j.async = true;
  //   j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
  //   f.parentNode.insertBefore(j, f);
  // })(window, document, 'script', 'dataLayer', 'GTM-TZKFMP96');

  // ----- Cookie Banner Behavior -----
  const banner = document.getElementById("cookie-banner");
  const modal = document.getElementById("cookie-modal");

  const showBanner = () => {
    if (banner) {
      banner.style.display = "flex";
      banner.classList.add("show");
      banner.classList.remove("hide");
    }
  };

  const hideBanner = () => {
    if (banner) {
      banner.style.display = "none";
      banner.classList.add("hide");
      banner.classList.remove("show");
    }
  };

  const showModal = () => modal && (modal.style.display = "block");
  const hideModal = () => modal && (modal.style.display = "none");

  const acceptAllBtn = document.getElementById("banner-accept-all");
  const customSettingsBtn = document.getElementById("banner-customize");
  const modalSaveBtn = document.getElementById("modal-save-preferences");
  const modalAcceptBtn = document.getElementById("modal-accept-all");
  const modalRejectBtn = document.getElementById("modal-reject-all");
  const modalCloseBtn = document.getElementById("close-modal");

  const checkAnalytics = document.getElementById("modal-data-checkbox");
  const checkMarketing = document.getElementById("modal-marketing-checkbox");
  const checkPerformance = document.getElementById(
    "modal-customization-checkbox",
  );
  const cookieLinkFooter = document.getElementById("cookie-link");

  if (!getTrackingConsent().cookie_set) showBanner();

  if (acceptAllBtn) {
    acceptAllBtn.addEventListener("click", () => {
      setConsentCookie(true, true, true);
      updateConsentInGTM({
        analytics: true,
        marketing: true,
        performance: true,
      });
      hideBanner();
    });
  }

  if (customSettingsBtn) {
    customSettingsBtn.addEventListener("click", () => {
      hideBanner();
      showModal();
    });
  }

  if (modalAcceptBtn) {
    modalAcceptBtn.addEventListener("click", () => {
      setConsentCookie(true, true, true);
      updateConsentInGTM({
        analytics: true,
        marketing: true,
        performance: true,
      });
      hideModal();
    });
  }

  if (modalRejectBtn) {
    modalRejectBtn.addEventListener("click", () => {
      setConsentCookie(false, false, false);
      updateConsentInGTM({
        analytics: false,
        marketing: false,
        performance: false,
      });
      hideModal();
    });
  }

  if (modalSaveBtn) {
    modalSaveBtn.addEventListener("click", () => {
      const analytics = checkAnalytics?.checked;
      const marketing = checkMarketing?.checked;
      const performance = checkPerformance?.checked;
      setConsentCookie(analytics, marketing, performance);
      updateConsentInGTM({ analytics, marketing, performance });
      hideModal();
    });
  }

  if (modalCloseBtn) {
    modalCloseBtn.addEventListener("click", () => {
      hideModal();
      showBanner();
    });
  }

  if (cookieLinkFooter) {
    cookieLinkFooter.addEventListener("click", () => {
      showBanner();
    });
  }

  // ----- Add Shopify events below (eg. Purchase Event, Abandoned cart, etc.) -----
})();

/**
 * Minimal dose price updater
 * Updates the minimal dose price, text and icon when a variant changes
 */
(function () {
  function updateMinimalDosePrice(variant) {
    const span = document.querySelector(".minimal-dose-price");
    if (!span || !variant) return;
    try {
      const variantPrices = JSON.parse(span.dataset.variantPrices || "{}");
      const content = variantPrices[variant.id];
      if (content) {
        span.textContent = content;
        span.closest(".minimal-dose-price-wrapper").style.display = "";
      } else {
        span.closest(".minimal-dose-price-wrapper").style.display = "none";
      }
    } catch (e) {
      span.closest(".minimal-dose-price-wrapper").style.display = "none";
    }
  }

  function updateMinimalDosageText(variant) {
    const span = document.querySelector(".minimal-dosage-content");
    if (!span || !variant) return;
    try {
      const variantContent = JSON.parse(span.dataset.variantContent || "{}");
      const content = variantContent[variant.id];
      if (content) {
        span.textContent = content;
      }
    } catch (e) {
      console.log(e);
    }
  }
  function updateMinimalDosageIcon(variant) {
    const span = document.querySelector(".minimal-dose-icon");
    if (!span || !variant) return;
    try {
      const variantContent = JSON.parse(span.dataset.variantContent || "{}");
      const content = variantContent[variant.id];
      if (content) {
        span.textContent = content;
      }
    } catch (e) {
      console.log(e);
    }
  }

  document.addEventListener("variant:changed", function (event) {
    const variant = event.detail && event.detail.variant;
    if (variant) {
      updateMinimalDosePrice(variant);
      updateMinimalDosageText(variant);
      updateMinimalDosageIcon(variant);
    }
  });
})();

/**
 * -------------------------------------------------------------------------------------------
 * MAIN COLLECTION FILTER
 * -------------------------------------------------------------------------------------------
 */

document.addEventListener("DOMContentLoaded", function () {
  const filterButtons = document.querySelectorAll(".filter-button");
  const mainProductContainer = document.getElementById(
    "product-list-container",
  );
  const archiveProductContainer = document.getElementById(
    "archive-product-list-container",
  );
  if (mainProductContainer) {
    const products = Array.from(
      mainProductContainer.querySelectorAll(".product-item-container"),
    );
    const archiveFilter = "produktarchiv";

    function activateFilter(selectedFilter) {
      filterButtons.forEach((btn) => btn.classList.remove("active"));
      const matchingButton = Array.from(filterButtons).find(
        (btn) => (btn.dataset.filter || "").trim().toLowerCase() === selectedFilter,
      );
      if (matchingButton) matchingButton.classList.add("active");

      if (selectedFilter === archiveFilter && archiveProductContainer) {
        mainProductContainer.style.display = "none";
        archiveProductContainer.style.display = "block";
      } else {
        mainProductContainer.style.display = "block";
        if (archiveProductContainer) {
          archiveProductContainer.style.display = "none";
        }
        filterProducts(selectedFilter);
      }

      const url = new URL(window.location);
      if (selectedFilter && selectedFilter !== "all_products") {
        url.searchParams.set("filter", selectedFilter);
      } else {
        url.searchParams.delete("filter");
      }
      history.replaceState(null, "", url);
    }

    filterButtons.forEach((button) => {
      button.addEventListener("click", function () {
        const selectedFilter = (this.dataset.filter || "").trim().toLowerCase();
        activateFilter(selectedFilter);
      });
    });

    function filterProducts(filter) {
      products.forEach((product) => {
        const normalizedFilter = (filter || "").trim().toLowerCase();
        const productTags = (product.dataset.tags || "")
          .split(",")
          .map((tag) => tag.trim().toLowerCase());
        const productIsArchived =
          (product.dataset.archived || "").trim().toLowerCase() === "true";

        const matchesFilter =
          normalizedFilter === "all_products" ||
          productTags.includes(normalizedFilter);

        if (matchesFilter && !productIsArchived) {
          product.style.display = "block";
        } else {
          product.style.display = "none";
        }
      });
    }

    const initialFilter =
      new URLSearchParams(window.location.search).get("filter") || "all_products";
    activateFilter(initialFilter.trim().toLowerCase());
  }
});

/**
 * -------------------------------------------------------------------------------------------
 * A.I. GENERATED IMAGE LABELS
 * -------------------------------------------------------------------------------------------
 */

(function () {
  const aiImageSelector = 'img[alt^="KI_"], img[alt^="KI-"]';

  function addAiGeneratedImageLabel(image) {
    if (image.dataset.aiGeneratedLabelled === "true") return;

    const picture = image.closest("picture");
    const wrapper = picture ? picture.parentElement : image.parentElement;

    if (!wrapper) return;

    if (window.getComputedStyle(wrapper).position === "static") {
      wrapper.style.position = "relative";
    }

    const label = document.createElement("span");
    label.classList.add("ai-generated-image-label");
    label.setAttribute("aria-hidden", "true");
    label.textContent = "A.I. generated";

    Array.from(image.classList)
      .filter((className) => className.startsWith("hidden-"))
      .forEach((className) => label.classList.add(className));

    (picture || image).insertAdjacentElement("afterend", label);
    image.dataset.aiGeneratedLabelled = "true";
  }

  function processAiGeneratedImages(root) {
    if (!(root instanceof Element) && root !== document) return;

    if (root instanceof Element && root.matches(aiImageSelector)) {
      addAiGeneratedImageLabel(root);
    }

    root
      .querySelectorAll(aiImageSelector)
      .forEach((image) => addAiGeneratedImageLabel(image));
  }

  processAiGeneratedImages(document);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => processAiGeneratedImages(node));
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
